import React from 'react';
import { Controller } from 'react-hook-form';
import { Button } from '@planne-software/uni/Button';
import { Input } from '@planne-software/uni/Input';
import { Alert } from '@planne-software/uni/Alert';
import { IconInfoCircle } from '@planne-software/uni/icons';

import { useTranslate } from '@src/core/hooks';

import { CouponApplyWrapper, CouponApplyButtonWrapper, CouponApplyInputWrapper, CouponApplyRow } from '../../styles';
import { useCartCouponApplyForm } from './useCartCouponApplyForm';

type CartCouponApplyProps = {
  disabled?: boolean;
};

export const CartCouponApply = (props: CartCouponApplyProps) => {
  const { disabled = false } = props;
  const { i18n } = useTranslate();
  const { control, isLoading, hasAppliedCoupon, errorMessage, isSubmitEnabled, onSubmit } = useCartCouponApplyForm();

  if (disabled || hasAppliedCoupon) {
    return null;
  }

  return (
    <CouponApplyWrapper>
      <form onSubmit={onSubmit} noValidate>
        <CouponApplyRow data-testid='cart-coupon-apply'>
          <CouponApplyInputWrapper>
            <Controller
              name='couponCode'
              control={control}
              render={({ field: { onChange, value, name, ref, ...rest } }) => (
                <Input
                  value={value ?? ''}
                  name={name}
                  ref={ref}
                  placeholder={i18n('checkout_coupon_placeholder')}
                  disabled={isLoading}
                  onChange={onChange}
                  fullWidth
                  size='medium'
                  {...rest}
                />
              )}
            />
          </CouponApplyInputWrapper>
          <CouponApplyButtonWrapper>
            <Button type='submit' variant='outlined' size='md' disabled={isLoading || !isSubmitEnabled}>
              {i18n('checkout_coupon_apply')}
            </Button>
          </CouponApplyButtonWrapper>
        </CouponApplyRow>
      </form>
      {errorMessage ? <Alert severity='error' title={errorMessage} startIcon={<IconInfoCircle />} /> : null}
    </CouponApplyWrapper>
  );
};

export default CartCouponApply;
